import {getAppVersion} from '@wix/music-shared/dist/src/wmp-shared/utils/env/getAppVersion';

export const artifactVersion: string = getAppVersion();
